import { createContext, useContext } from 'react';

export type Role = 'admin' | 'editor' | 'viewer';

export const ROLE_LABEL: Record<Role, string> = { admin: 'Admin', editor: 'Bearbeiter', viewer: 'Leser' };

export interface Account {
  id: string;
  name: string;
  email: string | null;
  role: Role;
}

export interface Providers {
  authDisabled: boolean;
  oidc: { name: string; label: string; autoLogin: boolean } | null;
}

export const AccountContext = createContext<Account | null>(null);

export const useAccount = () => useContext(AccountContext);

/** Viewers get a read-only UI (the API enforces it, too). Without an account context – e.g. in tests – editing is allowed. */
export function useCanEdit(): boolean {
  const account = useContext(AccountContext);
  return account ? account.role !== 'viewer' : true;
}

/** Budget/settings and the user list are for admins only. */
export function useIsAdmin(): boolean {
  const account = useContext(AccountContext);
  return account ? account.role === 'admin' : true;
}
